module.exports = __webpack_public_path__ + "public-ui/img/telegram.a6655943.svg";